module.exports = __webpack_public_path__ + "img/冰眸上线宣传海报封面.92dedde3.png";